import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './header';
import Footer from './footer';

export default class NotFound extends Component {
  render () {
    let {T} = this.props;
    return (
      <div>
          <Helmet>
            <html lang={T.translate('lang')}/>
            <title>{T.translate('title')}</title>
            <link rel="alternate" href={`${this.props.langUrl}#en`} hreflang="en" />
            <link rel="alternate" href={`${this.props.langUrl}#ja`} hreflang="ja" />
            <meta name="description" content={T.translate('meta.description')}/>
            <meta name="keywords" content={T.translate('meta.keywords')}/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content={T.translate('title')}/>
            <meta property="og:description" content={T.translate('meta.description')}/>
            <meta property="og:image" content={T.translate('meta.image')} />
            <meta property="og:url" content="https://generator.rabbit.gomobile.jp/" />
            <meta property="og:site_name" content={T.translate('title')}/>
            <meta property="fb:app_id" content="148089798643738" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:url" content="https://generator.rabbit.gomobile.jp/" />
            <meta name="twitter:title" content={T.translate('title')} />
            <meta name="twitter:description" content={T.translate('meta.description')} />
            <meta name="twitter:image" content={T.translate('meta.image')} />
            <meta name="twitter:site" content="@i3design_jp" />
          </Helmet>
        <Header />
        <main className="main-page result-page">
          <div className="wrapper">
          <span className="no-page-error"><T.text text={"not-found-title"}/></span>
          </div>
        </main>
        <Footer disableSocial={true} T={T}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/not-found.js